import React from 'react';

export default function EmptyResults({
    title = 'No results match your filters',
    message = 'Try adjusting search or filters, or clear them to see everything again.',
    onClear,
    clearLabel = 'Clear filters',
}) {
    return (
        <div className="gs-empty-state gs-empty-state--inline" role="status">
            <h2>{title}</h2>
            <p>{message}</p>
            {onClear && (
                <div className="gs-empty-state__actions">
                    <button type="button" className="gs-btn" onClick={onClear}>
                        {clearLabel}
                    </button>
                </div>
            )}
        </div>
    );
}
